export interface GossipItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  type: "video" | "image" | "text";
  cover: string;
  images: string[];
  tags: string[];
  heat: number;
  views: string;
  comments: number;
  date: string;
  author: string;
  content: string[];
}

export interface Category {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export const siteInfo = {
  brand: "瓜田前线",
  slogan: "全网热点吃瓜视觉合集",
  intro:
    "瓜田前线专注整理全网热门事件的视频、图片与实拍截图，把散落在各处的画面汇总到同一处，让你用最短时间看清事件的来龙去脉与热度走势。",
  email: "contact@guatianqianxian.example.com",
  weibo: "瓜田前线",
  sloganEn: "GUATIAN FRONTLINE",
};

export const categories: Category[] = [
  { slug: "yule", name: "娱乐爆料", desc: "演唱会、发布会、红毯与后台的一手画面合集。", icon: "ri-fire-line", count: 128 },
  { slug: "wanghong", name: "网红动态", desc: "直播间、短视频与线下偶遇的实时动态追踪。", icon: "ri-live-line", count: 96 },
  { slug: "yingshi", name: "影视综艺", desc: "片场路透、综艺录制与节目花絮的视觉整理。", icon: "ri-film-line", count: 74 },
  { slug: "dianjing", name: "电竞圈", desc: "赛事现场、选手台前幕后的精彩瞬间回放。", icon: "ri-gamepad-line", count: 58 },
  { slug: "shehui", name: "社会热点", desc: "公共场合的实拍画面与网络热议事件梳理。", icon: "ri-earth-line", count: 63 },
  { slug: "qinggan", name: "情感八卦", desc: "轻松向的日常八卦与人际互动观察合集。", icon: "ri-heart-3-line", count: 45 },
];

export const flashNews: string[] = [
  "顶流演唱会后台花絮图最新流出，排练细节被网友逐帧放大",
  "千万粉博主直播口误片段登顶热搜，弹幕刷屏名场面",
  "古装新剧片场路透实拍更新，主角造型首次完整曝光",
  "电竞总决赛决胜局现场画面流出，解说当场破音",
  "品牌发布会主持人救场截图刷屏，被赞情商教科书",
  "音乐节后台同框截图流出，多位歌手画面感拉满",
];

export const gossipItems: GossipItem[] = [
  {
    id: "star-concert-backstage",
    title: "顶流演唱会后台花絮图流出，深夜排练画面细节满满",
    summary:
      "一组演唱会后台与排练室的画面在社交平台流传，从走位标记到乐器摆放都被网友仔细解读，讨论热度持续走高。",
    category: "娱乐爆料",
    categorySlug: "yule",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20dramatic%20concert%20stage%20with%20crimson%20spotlights%20and%20light%20haze%2C%20empty%20arena%20before%20showtime%2C%20warm%20amber%20glow%20mixed%20with%20deep%20red%20tones%2C%20moody%20editorial%20photography%2C%20cinematic%20wide%20composition%2C%20no%20people&width=1200&height=750&seq=gua-01-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Abstract%20dramatic%20concert%20stage%20with%20crimson%20spotlights%20and%20light%20haze%2C%20empty%20arena%20before%20showtime%2C%20warm%20amber%20glow%20mixed%20with%20deep%20red%20tones%2C%20moody%20editorial%20photography%2C%20cinematic%20wide%20composition%2C%20no%20people&width=1200&height=750&seq=gua-01-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Backstage%20corridor%20of%20a%20large%20venue%20with%20warm%20wall%20lamps%2C%20flight%20cases%20and%20cables%20along%20the%20wall%2C%20soft%20amber%20lighting%2C%20clean%20minimal%20documentary%20photography%2C%20shallow%20depth%20of%20field%2C%20cream%20and%20terracotta%20palette&width=1200&height=750&seq=gua-01-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Rehearsal%20room%20with%20musical%20instruments%20and%20floor%20position%20markings%2C%20warm%20floor%20lamp%20light%2C%20wooden%20interior%20with%20soft%20shadows%2C%20calm%20documentary%20style%20photography%2C%20amber%20and%20ivory%20tones%2C%20quiet%20atmosphere&width=1200&height=750&seq=gua-01-c&orientation=landscape",
    ],
    tags: ["演唱会", "后台花絮", "排练现场"],
    heat: 9820,
    views: "32.6万",
    comments: 1284,
    date: "2026-09-10",
    author: "瓜田观察员",
    content: [
      "这组画面最早出现在社交平台的讨论区，拍摄角度多为侧后方，能清楚看到场馆内的灯光调试与走位标记。由于画面中保留了排练室的时间贴纸，不少网友据此推测演出前的准备周期比外界想象得更长。",
      "从曝光的花絮图来看，舞台侧台堆放着成排的演出箱，地面上用不同颜色的胶带标出了每个环节的站位。有熟悉演出的网友指出，这种标记方式通常用于多人同时走位的段落，说明整场演出在编排上下了不少功夫。",
      "值得关注的是，讨论的焦点并没有停留在艺人本身，而是转向了幕后团队的准备细节。有网友评论说，比起聚光灯下的舞台，这些安静的准备工作反而更打动人。",
      "截至发稿前，相关话题仍在持续升温。我们将继续整理后续流出的画面，并对关键时间点做可视化更新。",
    ],
  },
  {
    id: "blogger-live-slip",
    title: "千万粉博主直播片段被疯传，一句口误冲上热搜第一",
    summary:
      "一场常规直播中的临场口误被剪成短视频广泛传播，短时间内登上热搜首位，评论区玩梗不断。",
    category: "网红动态",
    categorySlug: "wanghong",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20neon%20lit%20streaming%20room%20with%20soft%20warm%20backlight%20and%20blurred%20screens%2C%20modern%20creator%20studio%20atmosphere%2C%20amber%20and%20coral%20glow%2C%20clean%20editorial%20photography%2C%20no%20readable%20text%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=gua-02-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Abstract%20neon%20lit%20streaming%20room%20with%20soft%20warm%20backlight%20and%20blurred%20screens%2C%20modern%20creator%20studio%20atmosphere%2C%20amber%20and%20coral%20glow%2C%20clean%20editorial%20photography%2C%20no%20readable%20text%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=gua-02-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20in%20a%20dark%20cozy%20room%2C%20warm%20bokeh%20lights%20in%20the%20background%2C%20intimate%20night%20atmosphere%2C%20terracotta%20and%20amber%20tones%2C%20minimal%20editorial%20photography%2C%20soft%20focus&width=1200&height=750&seq=gua-02-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20warm%20condenser%20microphone%20on%20a%20desk%20with%20acoustic%20foam%20panels%2C%20soft%20amber%20lighting%2C%20clean%20modern%20studio%20interior%2C%20minimal%20documentary%20photography%2C%20ivory%20and%20rust%20palette&width=1200&height=750&seq=gua-02-c&orientation=landscape",
    ],
    tags: ["直播", "热搜", "口误名场面"],
    heat: 9450,
    views: "28.1万",
    comments: 968,
    date: "2026-09-10",
    author: "瓜田观察员",
    content: [
      "事件起因是一场日常直播中的随口一答。由于当时的语境颇为轻松，博主并未立刻意识到自己说错了话，直到弹幕开始密集刷屏，直播间的气氛才逐渐热络起来。",
      "随后有观众把这段内容剪成十几秒的短视频发布，播放量在几个小时内迅速攀升。评论区里，大家更多是善意玩梗，把这句话做成各种表情包与口头禅。",
      "博主本人在稍晚的直播中回应了这件事，态度轻松，还主动复述了一遍。这种自嘲的处理方式获得不少好评，有网友认为，及时接住梗比强行解释更让人舒服。",
      "本次事件的传播路径很典型：直播间首发、短视频二次发酵、热搜完成破圈。我们把它记录在案，作为观察网络热点扩散的一个样本。",
    ],
  },
  {
    id: "costume-drama-set",
    title: "古装新剧片场路透实拍曝光，主角对戏氛围感拉满",
    summary:
      "一组片场实拍画面在网络流传，古朴的庭院布景与拍摄灯光同框，引来不少剧迷围观讨论。",
    category: "影视综艺",
    categorySlug: "yingshi",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20courtyard%20film%20set%20with%20red%20wooden%20pillars%20and%20stone%20path%2C%20soft%20warm%20afternoon%20light%2C%20lanterns%20hanging%20along%20the%20eaves%2C%20cinematic%20production%20photography%2C%20terracotta%20and%20amber%20palette%2C%20no%20people&width=1200&height=750&seq=gua-03-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20courtyard%20film%20set%20with%20red%20wooden%20pillars%20and%20stone%20path%2C%20soft%20warm%20afternoon%20light%2C%20lanterns%20hanging%20along%20the%20eaves%2C%20cinematic%20production%20photography%2C%20terracotta%20and%20amber%20palette%2C%20no%20people&width=1200&height=750&seq=gua-03-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Film%20lighting%20rig%20with%20softboxes%20and%20stands%20set%20up%20in%20a%20traditional%20courtyard%2C%20daylight%20balanced%20warm%20tungsten%20glow%2C%20behind%20the%20scenes%20documentary%20photography%2C%20clean%20composition%2C%20ivory%20and%20rust%20tones&width=1200&height=750&seq=gua-03-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Detailed%20traditional%20Chinese%20costume%20with%20embroidered%20patterns%20hanging%20on%20a%20wooden%20rack%2C%20warm%20indoor%20lighting%2C%20wardrobe%20department%20detail%20shot%2C%20elegant%20textile%20photography%2C%20no%20people&width=1200&height=750&seq=gua-03-c&orientation=landscape",
    ],
    tags: ["片场路透", "古装剧", "实拍画面"],
    heat: 8760,
    views: "21.4万",
    comments: 742,
    date: "2026-09-09",
    author: "剧集观察组",
    content: [
      "画面拍摄于摄制组位于郊外的实景基地。庭院中的木质廊柱与悬挂的灯笼构成了主要视觉元素，与常见的棚拍布景相比，实景的自然光过渡更柔和。",
      "从现场摆放的灯光设备来看，白天的戏份采用了日光与暖色补光结合的方式，既保留了古建筑的质感，也让演员的面部更立体。这类处理在近年的古装剧中越来越常见。",
      "除了布景，服装道具的细节也被网友放大讨论。绣有暗纹的长袍被整齐挂在木质衣架上，从面料垂坠感能看出用料讲究，与角色设定相符。",
      "需要提醒的是，路透画面只是拍摄现场的片段，与成片效果仍有差距。最终的剪辑、调色与配乐会带来完全不同的观感，追剧还是以正片为准。",
    ],
  },
  {
    id: "esports-final-moment",
    title: "电竞总决赛现场实拍流出，决胜局那波运营看呆解说",
    summary:
      "赛事现场的观众实拍画面流传开来，决胜局关键团战的瞬间被从看台角度完整记录，气氛拉满。",
    category: "电竞圈",
    categorySlug: "dianjing",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=Large%20esports%20arena%20interior%20with%20big%20screens%20and%20stage%20lighting%2C%20empty%20seats%20before%20the%20final%2C%20warm%20amber%20and%20red%20stage%20wash%2C%20cinematic%20wide%20shot%2C%20clean%20modern%20editorial%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-04-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Large%20esports%20arena%20interior%20with%20big%20screens%20and%20stage%20lighting%2C%20empty%20seats%20before%20the%20final%2C%20warm%20amber%20and%20red%20stage%20wash%2C%20cinematic%20wide%20shot%2C%20clean%20modern%20editorial%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-04-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gaming%20keyboard%20and%20headset%20on%20a%20competitive%20station%20desk%2C%20warm%20spotlight%20from%20above%2C%20red%20accent%20lighting%2C%20close%20up%20product%20photography%2C%20shallow%20depth%20of%20field%2C%20moody%20tones&width=1200&height=750&seq=gua-04-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Silhouette%20crowd%20in%20an%20arena%20raising%20phones%2C%20backlit%20by%20warm%20amber%20stage%20light%2C%20energetic%20event%20atmosphere%2C%20dramatic%20editorial%20photography%2C%20deep%20red%20and%20gold%20palette&width=1200&height=750&seq=gua-04-c&orientation=landscape",
    ],
    tags: ["总决赛", "赛事现场", "决胜局"],
    heat: 8210,
    views: "18.9万",
    comments: 653,
    date: "2026-09-09",
    author: "电竞观察席",
    content: [
      "这段画面由看台观众拍摄，虽然画质并非专业设备，但角度恰好记录了决胜局最关键的一次团战。从镜头晃动幅度能感受到现场的情绪起伏。",
      "让讨论热度上升的，是解说在那一瞬间的反应。由于局势反转来得太快，解说语速明显加快，几句连读被网友剪成音频反复播放。",
      "赛后复盘显示，这次团战的胜负并非偶然，而是建立在前几分钟的视野与资源交换之上。有分析帖把关键节点拆解成时间轴，方便新观众理解。",
      "现场画面之所以传播广泛，是因为它同时记录了比赛与观众两种情绪。对很多没能到场的玩家来说，这种沉浸感是隔着屏幕最容易共情的部分。",
    ],
  },
  {
    id: "brand-launch-moment",
    title: "品牌发布会现场截图刷屏，主持人临场救场被夸高情商",
    summary:
      "发布会进行中设备短暂故障，主持人现场圆场的一幕被截图传播，评论区纷纷表示专业度在线。",
    category: "社会热点",
    categorySlug: "shehui",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Press%20conference%20podium%20with%20microphones%20and%20warm%20spotlight%2C%20blurred%20backdrop%20in%20amber%20and%20cream%20tones%2C%20clean%20professional%20event%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20readable%20text%2C%20minimal%20composition&width=1200&height=750&seq=gua-05-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Press%20conference%20podium%20with%20microphones%20and%20warm%20spotlight%2C%20blurred%20backdrop%20in%20amber%20and%20cream%20tones%2C%20clean%20professional%20event%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20readable%20text%2C%20minimal%20composition&width=1200&height=750&seq=gua-05-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Empty%20stage%20with%20soft%20warm%20wash%20lighting%20and%20minimal%20backdrop%2C%20event%20hall%20before%20the%20show%2C%20clean%20architectural%20photography%2C%20terracotta%20and%20ivory%20palette%2C%20calm%20atmosphere&width=1200&height=750&seq=gua-05-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Audience%20hands%20and%20phones%20raised%20during%20an%20indoor%20event%2C%20warm%20amber%20ambient%20light%2C%20soft%20focus%20crowd%20photography%2C%20lively%20but%20orderly%20atmosphere%2C%20editorial%20tone&width=1200&height=750&seq=gua-05-c&orientation=landscape",
    ],
    tags: ["发布会", "现场截图", "主持现场"],
    heat: 7640,
    views: "15.2万",
    comments: 512,
    date: "2026-09-08",
    author: "热点记录组",
    content: [
      "事发时，发布会的演示环节出现短暂中断，大屏内容未能及时切换。现场一度安静了几秒，不少观众的注意力转向了台侧。",
      "主持人在确认情况后没有等待，而是顺势把话题引向产品背后的故事，用一段即兴讲述填补了空档。等到画面恢复，节奏几乎没有被打乱。",
      "有从事活动行业的网友分析，这类临场处理考验的是对内容的理解深度，而不是话术熟练度。只有真正了解产品，才能在无准备的情况下讲出有价值的信息。",
      "现场截图之所以被广泛转发，或许是因为它提供了一个正面样本：突发状况并不一定会破坏体验，处理得当反而能让观众感受到团队的专业。",
    ],
  },
  {
    id: "music-festival-backstage",
    title: "音乐节后台候场截图流出，几位歌手同框画面太有故事感",
    summary:
      "音乐节后台的一张候场合影在网络上流传，随性的状态与舞台上的形象形成有趣反差，引发大量转发。",
    category: "娱乐爆料",
    categorySlug: "yule",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20festival%20backstage%20tent%20with%20string%20lights%20and%20wooden%20crates%2C%20warm%20dusk%20light%20filtering%20through%20fabric%2C%20relaxed%20documentary%20photography%2C%20amber%20and%20terracotta%20palette%2C%20no%20readable%20text&width=1200&height=750&seq=gua-06-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Music%20festival%20backstage%20tent%20with%20string%20lights%20and%20wooden%20crates%2C%20warm%20dusk%20light%20filtering%20through%20fabric%2C%20relaxed%20documentary%20photography%2C%20amber%20and%20terracotta%20palette%2C%20no%20readable%20text&width=1200&height=750&seq=gua-06-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Acoustic%20guitars%20leaning%20against%20a%20wooden%20stand%20backstage%2C%20warm%20low%20light%20and%20soft%20shadows%2C%20intimate%20backstage%20detail%20photography%2C%20honey%20and%20rust%20tones%2C%20no%20people&width=1200&height=750&seq=gua-06-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Festival%20crowd%20silhouettes%20against%20warm%20amber%20stage%20lights%20at%20dusk%2C%20distant%20stage%20glow%2C%20atmospheric%20event%20photography%2C%20deep%20orange%20and%20cream%20gradient%20sky%2C%20cinematic%20wide%20shot&width=1200&height=750&seq=gua-06-c&orientation=landscape",
    ],
    tags: ["音乐节", "后台", "同框画面"],
    heat: 7120,
    views: "13.7万",
    comments: 428,
    date: "2026-09-08",
    author: "瓜田观察员",
    content: [
      "这张截图来自后台区域的随手一拍，几位歌手的站位并不规整，有人站着，有人靠着箱子，状态相当放松。正是这种不加修饰的氛围，让画面显得格外真实。",
      "有长期跑音乐节的乐迷指出，后台往往比舞台更能看出音乐人的真实状态。演出前的等待时间很长，大家通常会用聊天、试音或即兴弹奏来打发。",
      "画面中出现的乐器与道具也成了讨论对象。有眼尖的网友根据吉他背带的花纹，认出了其中一位常用乐手的私藏装备。",
      "比起精心设计的宣传照，这类候场画面更像是节日的日常切片。或许也正因为如此，它才更容易让人产生共鸣。",
    ],
  },
  {
    id: "variety-show-recording",
    title: "综艺录制路透图集曝光，嘉宾互动细节被网友逐帧分析",
    summary:
      "一档热门综艺的录制路透图集在网络流传，嘉宾之间的自然互动被反复回看，衍生出不少讨论话题。",
    category: "影视综艺",
    categorySlug: "yingshi",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20warm%20practical%20lamps%20and%20wooden%20furniture%2C%20cozy%20variety%20show%20stage%2C%20soft%20amber%20lighting%2C%20clean%20production%20photography%2C%20ivory%20and%20terracotta%20palette%2C%20no%20people&width=1200&height=750&seq=gua-07-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20warm%20practical%20lamps%20and%20wooden%20furniture%2C%20cozy%20variety%20show%20stage%2C%20soft%20amber%20lighting%2C%20clean%20production%20photography%2C%20ivory%20and%20terracotta%20palette%2C%20no%20people&width=1200&height=750&seq=gua-07-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Row%20of%20empty%20stools%20and%20a%20low%20table%20on%20a%20warmly%20lit%20talk%20show%20stage%2C%20soft%20background%20bokeh%2C%20minimal%20editorial%20photography%2C%20honey%20amber%20and%20cream%20tones%2C%20calm%20composition&width=1200&height=750&seq=gua-07-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Professional%20video%20camera%20on%20a%20tripod%20with%20warm%20studio%20lighting%20in%20the%20background%2C%20behind%20the%20scenes%20detail%20shot%2C%20muted%20rust%20and%20ivory%20palette%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=gua-07-c&orientation=landscape",
    ],
    tags: ["综艺路透", "录制现场", "互动细节"],
    heat: 6840,
    views: "12.3万",
    comments: 386,
    date: "2026-09-07",
    author: "剧集观察组",
    content: [
      "这组图集记录了节目录制间隙的多个瞬间，与正片中紧凑的剪辑节奏不同，路透画面展示了嘉宾在等待时的真实状态。",
      "被讨论最多的是嘉宾之间的即时反应。有网友把几个画面拼在一起，指出某位嘉宾在听到同伴发言时的表情变化，认为这比台词本身更有信息量。",
      "也有观众提醒，路透图集只是碎片，不能替代完整节目。脱离上下文的画面很容易被过度解读，追综艺还是应该以正片为准。",
      "从内容运营的角度看，路透图集确实能有效维持节目的讨论热度。对制作方而言，如何在宣传与剧透之间找到平衡，是长期课题。",
    ],
  },
  {
    id: "crew-night-wrap",
    title: "剧组深夜收工实拍画面走红，全员状态被赞敬业",
    summary:
      "一段剧组深夜收工的实拍画面流传开来，灯光与轨道设备仍在忙碌撤场，画面透着真实的疲惫感。",
    category: "影视综艺",
    categorySlug: "yingshi",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20street%20film%20set%20with%20warm%20production%20lights%20and%20cables%20on%20the%20ground%2C%20crew%20packing%20equipment%2C%20moody%20amber%20glow%20against%20deep%20blue%20hour%2C%20documentary%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-08-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Night%20street%20film%20set%20with%20warm%20production%20lights%20and%20cables%20on%20the%20ground%2C%20crew%20packing%20equipment%2C%20moody%20amber%20glow%20against%20deep%20blue%20hour%2C%20documentary%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-08-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Clapperboard%20and%20portable%20light%20on%20a%20road%20case%2C%20warm%20directional%20lighting%2C%20film%20production%20equipment%20close%20up%2C%20muted%20rust%20and%20charcoal%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=gua-08-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Film%20set%20at%20dusk%20with%20light%20stands%20silhouetted%20against%20warm%20orange%20sky%2C%20quiet%20city%20street%2C%20atmospheric%20cinematic%20photography%2C%20moody%20and%20calm%2C%20no%20people%20close%20up&width=1200&height=750&seq=gua-08-c&orientation=landscape",
    ],
    tags: ["剧组", "深夜收工", "幕后"],
    heat: 6320,
    views: "10.8万",
    comments: 341,
    date: "2026-09-07",
    author: "剧集观察组",
    content: [
      "画面拍摄于收工之后的后半夜，街面上还散落着灯架与线缆。虽然没有台词与表演，但撤场的整个过程本身就是一种叙事。",
      "不少从事影视行业的网友在评论区留言，认为这段画面真实还原了剧组的日常节奏。拍摄周期内熬夜几乎是常态，收工并不意味着结束，设备清点与转场安排同样耗时。",
      "也有观众从这段画面延伸开来，讨论作品背后的分工协作。一部剧的完成涉及摄影、灯光、美术、录音等多个工种，任何一环掉链子都会影响整体。",
      "我们把这组画面整理存档，作为幕后观察系列的一部分。后续会继续补充不同岗位的工作切片。",
    ],
  },
  {
    id: "airport-street-style",
    title: "机场实拍画面流出，低调穿搭引发同款搜索热潮",
    summary:
      "一张机场抓拍画面被广泛转发，简约的搭配反而成为焦点，相关同款在电商平台搜索量明显上涨。",
    category: "网红动态",
    categorySlug: "wanghong",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Airport%20terminal%20interior%20with%20large%20windows%20and%20soft%20daylight%2C%20warm%20neutral%20architecture%2C%20empty%20concourse%20before%20departure%2C%20clean%20editorial%20photography%2C%20cream%20and%20taupe%20palette%2C%20no%20people%20close%20up&width=1200&height=750&seq=gua-09-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Airport%20terminal%20interior%20with%20large%20windows%20and%20soft%20daylight%2C%20warm%20neutral%20architecture%2C%20empty%20concourse%20before%20departure%2C%20clean%20editorial%20photography%2C%20cream%20and%20taupe%20palette%2C%20no%20people%20close%20up&width=1200&height=750&seq=gua-09-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Leather%20travel%20bag%20and%20suitcase%20on%20a%20tiled%20airport%20floor%2C%20soft%20warm%20window%20light%2C%20minimal%20travel%20still%20life%20photography%2C%20ivory%20and%20terracotta%20tones%2C%20no%20people&width=1200&height=750&seq=gua-09-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20neutral%20tone%20clothing%20flat%20lay%20on%20light%20linen%20background%2C%20warm%20soft%20lighting%2C%20minimal%20fashion%20detail%20photography%2C%20beige%20and%20rust%20palette%2C%20clean%20composition&width=1200&height=750&seq=gua-09-c&orientation=landscape",
    ],
    tags: ["机场实拍", "穿搭", "同款"],
    heat: 5980,
    views: "9.6万",
    comments: 297,
    date: "2026-09-06",
    author: "瓜田观察员",
    content: [
      "这张抓拍没有任何摆拍痕迹，人物行走在航站楼的通道里，光线来自落地窗，整体呈现出很自然的明暗过渡。",
      "引发讨论的是穿搭本身。与常见的夸张造型不同，这套搭配以低饱和中性色为主，版型利落，普通人也容易参考。评论区里，不少人询问具体的款式与配色思路。",
      "随后一段时间，电商平台上相关关键词的搜索量出现明显上涨。有从业者分析，这说明当下消费者更偏好可复制、易日常的穿搭模板。",
      "当然，跟随潮流也要量力而行。适合自己的版型和材质，永远比追逐同款更重要。",
    ],
  },
  {
    id: "fashion-show-front-row",
    title: "时尚大秀前排座位图曝光，同框合影瞬间冲上话题榜",
    summary:
      "秀场前排的座位安排图在社交平台流传，几位嘉宾的相邻座次与同框瞬间成为大家热议的焦点。",
    category: "娱乐爆料",
    categorySlug: "yule",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Fashion%20runway%20with%20warm%20spotlights%20and%20a%20long%20reflective%20floor%2C%20empty%20catwalk%20before%20the%20show%2C%20elegant%20amber%20and%20champagne%20lighting%2C%20high%20end%20editorial%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-10-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Fashion%20runway%20with%20warm%20spotlights%20and%20a%20long%20reflective%20floor%2C%20empty%20catwalk%20before%20the%20show%2C%20elegant%20amber%20and%20champagne%20lighting%2C%20high%20end%20editorial%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-10-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Row%20of%20minimal%20chairs%20with%20cream%20cushions%20along%20a%20runway%2C%20warm%20directional%20light%2C%20refined%20event%20detail%20photography%2C%20champagne%20gold%20and%20ivory%20palette%2C%20no%20people&width=1200&height=750&seq=gua-10-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20luxurious%20fabric%20with%20fine%20texture%20and%20warm%20sheen%2C%20elegant%20textile%20detail%20shot%2C%20soft%20amber%20lighting%2C%20silk%20and%20velvet%20tones%2C%20minimal%20fashion%20photography&width=1200&height=750&seq=gua-10-c&orientation=landscape",
    ],
    tags: ["时尚大秀", "前排同框", "话题榜"],
    heat: 5640,
    views: "8.9万",
    comments: 264,
    date: "2026-09-06",
    author: "时尚观察席",
    content: [
      "秀场的座位安排向来是观察社交关系的一个窗口。这张座位图之所以被反复讨论，是因为几位嘉宾的相邻关系颇具看点。",
      "现场流出的画面显示，嘉宾们在等待开场的间隙有过短暂的交流。由于现场音乐声较大，交流多为点头与微笑，具体内容不得而知，但氛围看起来相当融洽。",
      "有从事品牌公关的网友解释，秀场座位通常需要兼顾品牌关系、媒体曝光与嘉宾意愿，最终方案往往是多方协调的结果。因此，座次本身并不能简单等同于亲疏远近。",
      "抛开这些猜测，秀场真正的重点仍然是设计作品本身。我们建议把注意力更多放在服装的剪裁与材质上，那才是时装周的核心。",
    ],
  },
  {
    id: "late-night-food-stall",
    title: "深夜大排档偶遇画面被拍，接地气互动圈粉无数",
    summary:
      "一段深夜大排档的偶遇画面在网络流传，随和的互动方式获得大量好评，评论区直呼真实可爱。",
    category: "情感八卦",
    categorySlug: "qinggan",
    type: "image",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20food%20stall%20with%20warm%20paper%20lanterns%20and%20rising%20steam%2C%20cozy%20street%20food%20atmosphere%2C%20amber%20light%20against%20dark%20background%2C%20atmospheric%20documentary%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-11-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Night%20food%20stall%20with%20warm%20paper%20lanterns%20and%20rising%20steam%2C%20cozy%20street%20food%20atmosphere%2C%20amber%20light%20against%20dark%20background%2C%20atmospheric%20documentary%20photography%2C%20no%20readable%20text&width=1200&height=750&seq=gua-11-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Warm%20hanging%20lanterns%20above%20a%20busy%20night%20market%20lane%2C%20soft%20bokeh%2C%20cozy%20evening%20mood%2C%20terracotta%20and%20honey%20tones%2C%20cinematic%20photography%2C%20no%20people%20close%20up&width=1200&height=750&seq=gua-11-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Simple%20late%20night%20dishes%20on%20a%20small%20folding%20table%2C%20warm%20overhead%20light%2C%20rustic%20food%20photography%2C%20terracotta%20and%20cream%20palette%2C%20cozy%20and%20inviting%20composition&width=1200&height=750&seq=gua-11-c&orientation=landscape",
    ],
    tags: ["深夜偶遇", "大排档", "接地气"],
    heat: 5280,
    views: "8.1万",
    comments: 238,
    date: "2026-09-05",
    author: "瓜田观察员",
    content: [
      "画面拍自城市里一家开了多年的夜宵摊，灯光昏黄，人来人往。被拍到的人坐在塑料凳上，与摊主有说有笑，完全没有距离感。",
      "让网友觉得有意思的，是整个过程里没有任何刻意。点单、等餐、聊天，都是再普通不过的日常，正因为普通，才显得真实。",
      "评论区里，很多人分享了自己在城市夜宵摊的回忆。有人说，深夜的小摊是最能卸下防备的地方，一碗热汤就足以治愈一整天的疲惫。",
      "或许这也是这类画面能打动人的原因：它不提供任何八卦价值，只提供一种熟悉的、带着烟火气的共鸣。",
    ],
  },
  {
    id: "gala-rehearsal-leak",
    title: "跨年晚会影响彩排视频流出，舞台设计提前曝光",
    summary:
      "一段跨年晚会的彩排视频在网络流传，从灯光编程到升降台走位都被记录下来，引发观众的提前期待。",
    category: "影视综艺",
    categorySlug: "yingshi",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=Large%20stage%20under%20construction%20with%20lighting%20trusses%20and%20LED%20panels%2C%20warm%20amber%20work%20lights%2C%20empty%20auditorium%20ahead%20of%20a%20show%2C%20cinematic%20architectural%20photography%2C%20no%20readable%20text%2C%20dramatic%20scale&width=1200&height=750&seq=gua-12-a&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Large%20stage%20under%20construction%20with%20lighting%20trusses%20and%20LED%20panels%2C%20warm%20amber%20work%20lights%2C%20empty%20auditorium%20ahead%20of%20a%20show%2C%20cinematic%20architectural%20photography%2C%20no%20readable%20text%2C%20dramatic%20scale&width=1200&height=750&seq=gua-12-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Lighting%20truss%20with%20moving%20head%20fixtures%20lit%20in%20warm%20amber%20and%20red%2C%20dark%20venue%20interior%2C%20technical%20stage%20photography%2C%20dramatic%20contrast%2C%20clean%20modern%20composition&width=1200&height=750&seq=gua-12-b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Rows%20of%20empty%20auditorium%20seats%20with%20warm%20ambient%20lighting%20from%20the%20stage%2C%20quiet%20before%20the%20show%2C%20moody%20editorial%20photography%2C%20terracotta%20and%20charcoal%20tones%2C%20no%20people&width=1200&height=750&seq=gua-12-c&orientation=landscape",
    ],
    tags: ["跨年晚会", "彩排流出", "舞台设计"],
    heat: 4920,
    views: "7.4万",
    comments: 205,
    date: "2026-09-05",
    author: "剧集观察组",
    content: [
      "这段彩排视频记录了舞台搭建完成后的首次完整联排。从画面可以看到，主舞台采用了多层次升降结构，配合环绕式的灯架，视觉纵深相当夸张。",
      "值得留意的是灯光编程的部分。工作人员正在逐条调试光位，暖色与红色交替出现，用来测试不同节目段落之间的过渡效果。这些细节平时很难被观众看到。",
      "有舞美从业者在评论中科普，大型晚会的舞台设计通常要提前数月规划，因为升降、威亚等机械结构涉及严格的安全测试，容错空间很小。",
      "视频流出后，不少观众表示对跨年夜更期待了。不过也要提醒，彩排版本与最终呈现仍有差异，正式演出时会有更多惊喜。",
    ],
  },
];

export const ranking: { id: string; title: string; heat: number; category: string; tag: string }[] = [
  { id: "blogger-live-slip", title: "千万粉博主直播口误登顶热搜", heat: 9450, category: "网红动态", tag: "爆" },
  { id: "star-concert-backstage", title: "顶流演唱会后台花絮图流出", heat: 9820, category: "娱乐爆料", tag: "热" },
  { id: "esports-final-moment", title: "电竞总决赛决胜局现场画面", heat: 8210, category: "电竞圈", tag: "热" },
  { id: "costume-drama-set", title: "古装新剧片场路透实拍曝光", heat: 8760, category: "影视综艺", tag: "新" },
  { id: "brand-launch-moment", title: "发布会主持人临场救场被夸高情商", heat: 7640, category: "社会热点", tag: "新" },
  { id: "music-festival-backstage", title: "音乐节后台候场截图流出", heat: 7120, category: "娱乐爆料", tag: "荐" },
  { id: "variety-show-recording", title: "综艺录制路透图集被逐帧分析", heat: 6840, category: "影视综艺", tag: "荐" },
];

export const testimonials: { name: string; role: string; text: string; avatar: string }[] = [
  {
    name: "夜猫子小陈",
    role: "资深吃瓜群众",
    text: "以前追热点要翻好几个平台，现在来瓜田前线就能一次看全，图集整理得很清楚，省时间。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20abstract%20portrait%20avatar%20with%20soft%20amber%20light%20and%20cream%20background%2C%20minimal%20illustration%20style%2C%20no%20recognizable%20face%2C%20clean%20modern%20art&width=200&height=200&seq=ava-01&orientation=squarish",
  },
  {
    name: "追剧的阿芸",
    role: "影视爱好者",
    text: "片场路透和幕后花絮是我最喜欢的板块，很多细节正片里看不到，这里整理得很用心。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20abstract%20portrait%20avatar%20with%20soft%20terracotta%20light%20and%20ivory%20background%2C%20minimal%20illustration%20style%2C%20no%20recognizable%20face%2C%20clean%20modern%20art&width=200&height=200&seq=ava-02&orientation=squarish",
  },
  {
    name: "电竞老张",
    role: "赛事观众",
    text: "总决赛那场的现场视角太有代入感了，比单纯看回放更过瘾，希望多更新赛事现场画面。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20abstract%20portrait%20avatar%20with%20soft%20honey%20light%20and%20beige%20background%2C%20minimal%20illustration%20style%2C%20no%20recognizable%20face%2C%20clean%20modern%20art&width=200&height=200&seq=ava-03&orientation=squarish",
  },
  {
    name: "吃瓜不上头",
    role: "内容观察者",
    text: "难得的是没有添油加醋，把画面和时间点摆出来，让大家自己判断，这种克制很难得。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20abstract%20portrait%20avatar%20with%20soft%20rust%20light%20and%20cream%20background%2C%20minimal%20illustration%20style%2C%20no%20recognizable%20face%2C%20clean%20modern%20art&width=200&height=200&seq=ava-04&orientation=squarish",
  },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: "瓜田前线的内容主要来自哪里？",
    a: "我们整理的是网络上公开流传的视频、图片与截图，并对画面做时间与来源的标注。所有内容都会经过基础核对，避免传播明显失实的信息。",
  },
  {
    q: "页面上的画面为什么有时会有模糊或遮挡？",
    a: "部分素材本身来自现场抓拍或手机录制，画质有限；同时对涉及个人隐私的部分，我们会在必要时做模糊处理，这是内容审核的基本要求。",
  },
  {
    q: "热瓜榜单是怎么计算的？",
    a: "榜单综合了内容的浏览量、讨论量与传播速度，每隔一段时间更新一次。它反映的是当下的关注度，并不代表对事件本身的评价。",
  },
  {
    q: "可以在瓜田前线投稿画面吗？",
    a: "可以。你可以通过页面底部的邮箱与我们联系，并附上画面的时间、地点等基本信息。我们会先做真实性核验，再决定是否收录。",
  },
  {
    q: "如何第一时间收到更新？",
    a: "建议收藏本站首页，热瓜速览与榜单会持续滚动更新。你也可以订阅页面底部的更新提醒，有新瓜料时会收到通知。",
  },
];

export const stats: { label: string; value: string; icon: string }[] = [
  { label: "收录瓜料", value: "1,280+", icon: "ri-article-line" },
  { label: "视觉画面", value: "6,400+", icon: "ri-image-2-line" },
  { label: "日更新", value: "40+", icon: "ri-refresh-line" },
  { label: "活跃吃瓜人", value: "86万", icon: "ri-group-line" },
];

export function getItemById(id: string): GossipItem | undefined {
  return gossipItems.find((item) => item.id === id);
}

export function getItemsByCategory(slug: string): GossipItem[] {
  return gossipItems.filter((item) => item.categorySlug === slug);
}

export function getRelatedItems(id: string, limit: number = 3): GossipItem[] {
  const current = getItemById(id);
  if (!current) return gossipItems.slice(0, limit);
  const sameCategory = gossipItems.filter(
    (item) => item.id !== id && item.categorySlug === current.categorySlug
  );
  const others = gossipItems.filter(
    (item) => item.id !== id && item.categorySlug !== current.categorySlug
  );
  return [...sameCategory, ...others].slice(0, limit);
}